import React, { useEffect, useState } from "react";
import { Paper, PaperProps } from "@mui/material";
import { ColleagueCardFooter } from "../components/ColleagueCardFooter/colleague-card-footer.component";
import { ColleagueCardHeader } from "../components/ColleagueCardHeader/colleague-card-header.component";
import { ColleagueCardPermissions } from "../components/ColleagueCardPermissions/colleague-card-permissions.component";
import { Colleague } from "../types/Colleague.type";

type P = {
  /** single colleague infomation */
  colleague: Colleague;
  onRefetch: () => void;
};

const ColleagueCard: React.FC<P> = ({ colleague, onRefetch }) => {
  const [editedColleague, setEditedColleague] = useState(colleague);

  useEffect(() => {
    setEditedColleague(colleague);
  }, [colleague]);

  return (
    <StyledColleagueCardPaper data-testid="colleague-card">
      <ColleagueCardHeader colleague={colleague} />
      <ColleagueCardPermissions
        colleague={colleague}
        editedColleague={editedColleague}
        setEditedColleague={setEditedColleague}
        onRefetch={onRefetch}
      />
      <ColleagueCardFooter
        colleague={colleague}
        editedColleague={editedColleague}
        setEditedColleague={setEditedColleague}
        onRefetch={onRefetch}
      />
    </StyledColleagueCardPaper>
  );
};

export default ColleagueCard;

export function StyledColleagueCardPaper(props: PaperProps) {
  return (
    <Paper
      {...props}
      sx={{
        borderRadius: "8px",
        position: "relative",
        width: 300,
        padding: 1.25, // 10px
        margin: "10px 10px 10px 0",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        flexWrap: "wrap",
        textAlign: "center",
        ...props.sx // allow overrides
      }}
    />
  );
}
